<template>
    <div id="liquor">
        <a-drawer :maskClosable="false" class="liquorDrawerLeft" :title="drawerTitle" placement="left"
            :visible="visible" width="1184" @close="closeDrawer">
            <a-row type="flex" justify="start" class="headerSteps" align="middle">
                <a-col class="sbxs" :class='[isview=="nonMerStep1" ? "stepsAvtiveBorder" : ""]'
                    @click="menuGoType('nonMerStep1')">
                    <a-row type="flex" justify="start" align="middle">
                        <a-col>
                            <img src="../../../assets/img/Liquor-inv.png" width="20" height="20">
                        </a-col>
                        <a-col style="text-align: center;" class="ml4">
                            <a-row class="headerStepsTitle">Select</a-row>
                            <a-row class="headerStepsTitle">Inventory</a-row>
                        </a-col>
                    </a-row>
                </a-col>

                <a-col style="width: 15%;text-align: center">
                    <img src="../../../assets/img/Lirutor_arrow.png" alt="">
                </a-col>

                <a-col class="sbxs" :class='[isview=="nonMerStep2" ? "stepsAvtiveBorder" : ""]'
                    @click="menuGoType('nonMerStep2')">
                    <a-row type="flex" justify="start" align="middle">
                        <a-col>
                            <img src="../../../assets/img/Liquor-ord.png" width="20" height="20">
                        </a-col>
                        <a-col style="text-align: center;" class="ml4">
                            <a-row class="headerStepsTitle">Order</a-row>
                            <a-row class="headerStepsTitle">Detail</a-row>
                        </a-col>
                    </a-row>
                </a-col>

                <a-col style="width: 15%;text-align: center">
                    <img src="../../../assets/img/Lirutor_arrow.png" alt="">
                </a-col>

                <a-col class="sbxs" :class='[isview=="nonMerStep3" ? "stepsAvtiveBorder" : ""]'
                    @click="menuGoType('nonMerStep3')">
                    <a-row type="flex" justify="start" align="middle">
                        <a-col>
                            <img src="../../../assets/img/Liquor-delive.png" width="20" height="20">
                        </a-col>
                        <a-col style="text-align: center;" class="ml4">
                            <a-row class="headerStepsTitle">Delivery</a-row>
                            <a-row class="headerStepsTitle">Information</a-row>
                        </a-col>
                    </a-row>
                </a-col>

                <a-col class="sbxs" style="width: 15%;text-align: center">
                    <img src="../../../assets/img/Lirutor_arrow.png" alt="">
                </a-col>

                <a-col class="sbxs" :class='[isview=="nonMerStep4" ? "stepsAvtiveBorder" : ""]'
                    @click="menuGoType('nonMerStep4')">
                    <a-row type="flex" justify="start" align="middle">
                        <a-col>
                            <img src="../../../assets/img/Liquor-ship.png" width="20" height="20">
                        </a-col>
                        <a-col style="text-align: center;" class="ml4">
                            <a-row class="headerStepsTitle">Shipment</a-row>
                            <a-row class="headerStepsTitle">Instruction</a-row>
                        </a-col>
                    </a-row>
                </a-col>

                <a-col class="sbxs" style="width: 15%;text-align: center">
                    <img src="../../../assets/img/Lirutor_arrow.png" alt="">
                </a-col>

                <a-col class="sbxs" :class='[isview=="nonMerStep5" ? "stepsAvtiveBorder" : ""]'
                    @click="menuGoType('nonMerStep5')">
                    <a-row type="flex" justify="start" align="middle">
                        <a-col>
                            <img src="../../../assets/img/Liquor-orderSum.png" width="20" height="20">
                        </a-col>
                        <a-col style="text-align: center;" class="ml4">
                            <a-row class="headerStepsTitle">Order</a-row>
                            <a-row class="headerStepsTitle">Summary</a-row>
                        </a-col>
                    </a-row>
                </a-col>

            </a-row>
            <!-- <keep-alive include="nonMerStep1,nonMerStep2,nonMerStep3,nonMerStep4,nonMerStep5"> -->
            <!-- <transition mode="out-in"> -->
            <component :is="isview" :ref="'ref'+isview" :dudfData="orderByInventoryData" :nonMerOrder="nonMerOrder"
                v-on:goType="getGoType" v-on:goClose="getGoClose"></component>
            <!-- </transition> -->
            <!-- </keep-alive> -->

            <!--关闭页面的弹出窗口-->
            <confirm3Button ref="confirm3Button" @closeWindowBack="closeWindowBack"></confirm3Button>

        </a-drawer>
    </div>
</template>
<script>
    import nonMerStep1 from './coms/nonMerStep1.vue'
    import nonMerStep2 from './coms/nonMerStep2.vue'
    import nonMerStep3 from './coms/nonMerStep3.vue'
    import nonMerStep4 from './coms/nonMerStep4.vue'
    import nonMerStep5 from './coms/nonMerStep5.vue'
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import moment from "moment";
    import confirm3Button from "../components/confirm3Button";
    export default {
        components: {
            nonMerStep1,
            nonMerStep2,
            nonMerStep3,
            nonMerStep4,
            nonMerStep5,
            confirm3Button,
        },
        data() {
            return {
                isview: 'nonMerStep1',
                visible: false,
                sellLiquor: {},
                initCloseValue: undefined,
                stepSelectData: {}, // 下拉请求数据
                drawerTitle: 'Order Creation - Step1',
                orderByInventoryData: {}, //T_INV_BAL_UDF.DUDF_01~3查询条件配置的名称
                nonMerOrder: {}, // 存step 1 ~ step 5 的所有信息
            }

        },
        watch: {
            isview(val) {
                if (val == 'nonMerStep1') {
                    this.drawerTitle = 'Order Creation - Step1'
                } else if (val == 'nonMerStep2') {
                    this.drawerTitle = 'Order Creation - Step2'
                } else if (val == 'nonMerStep3') {
                    this.drawerTitle = 'Order Creation - Step3'
                } else if (val == 'nonMerStep4') {
                    this.drawerTitle = 'Order Creation - Step4'
                } else if (val == 'nonMerStep5') {
                    this.drawerTitle = 'Order Creation - Step5'
                }
                // this.findTempSoValAjax()
            }
        },
        methods: {
            moment,
            show(orderByInventoryData) {
                this.orderByInventoryData = orderByInventoryData; // 动态Label
                ajax.post(api.INVWINEFINDTEMPSOORDERNONMER).then(res => { // 查询用户存在的临时数据
                    if (res.data == null || res.data == '') { // 数据库不存在任何信息
                        // 默认启动Step1
                        this.nonMerOrder = {}
                        this.isview = "nonMerStep1"
                    } else {

                        this.nonMerOrder = res.data;
                        this.isview = "nonMerStep" + res.data.currentStep;

                        // 格式化购物车
                        let nonMerOrderDetails = res.data.nonMerOrderDetails
                        if (nonMerOrderDetails != null && nonMerOrderDetails.length > 0) {
                            let groupNonMerOrderDetails = [];
                            for (let item of nonMerOrderDetails) {
                                // console.info('8787')
                                let flag = true;
                                for (let detail of groupNonMerOrderDetails) {
                                    if (detail.sku == item.sku && detail.skuUom == item.skuUom) {
                                        let skuInv = {}
                                        skuInv.dudf01 = item.dudf01
                                        skuInv.dudf02 = item.dudf02
                                        skuInv.dudf03 = item.dudf03
                                        skuInv.locationCode = item.locationCode
                                        skuInv.barcode = item.barcode
                                        skuInv.orderQty = item.orderQty
                                        detail.sumOrderQty = detail.sumOrderQty + item.orderQty
                                        detail.skuOrderData.push(skuInv)
                                        flag = false;
                                        break;
                                    }
                                }
                                if (flag) {
                                    let detail = {};
                                    detail.imageUrl = item.imageUrl,
                                        detail.sku = item.sku,
                                        detail.skuDes = item.skuDes,
                                        detail.skuUom = item.skuUom,
                                        detail.sumOrderQty = item.orderQty == null ? 0 : item.orderQty
                                    detail.skuOrderData = []
                                    let skuInv = {}
                                    skuInv.dudf01 = item.dudf01
                                    skuInv.dudf02 = item.dudf02
                                    skuInv.dudf03 = item.dudf03
                                    skuInv.locationCode = item.locationCode
                                    skuInv.barcode = item.barcode
                                    skuInv.orderQty = item.orderQty
                                    detail.skuOrderData.push(skuInv)
                                    groupNonMerOrderDetails.push(detail)
                                }
                            }
                            this.nonMerOrder.nonMerOrderDetails = groupNonMerOrderDetails
                        }



                    }
                })
                if (this.isview == "nonMerStep1") { // 加载页面所有的 Inv 数据
                    let refnonMerStep1 = this.$refs.refnonMerStep1;
                    if (refnonMerStep1 != null) { //  页面二次加载，手动刷新RefnonMerStep1
                        refnonMerStep1.searchTable()
                    }
                }



                this.visible = true
                if (this.isview == 'nonMerStep1') {
                    this.drawerTitle = 'Order Creation - Step1'
                } else if (this.isview == 'nonMerStep2') {
                    this.drawerTitle = 'Order Creation - Step2'
                } else if (this.isview == 'nonMerStep3') {
                    this.drawerTitle = 'Order Creation - Step3'
                } else if (this.isview == 'nonMerStep4') {
                    this.drawerTitle = 'Order Creation - Step4'
                } else if (this.isview == 'nonMerStep5') {
                    this.drawerTitle = 'Order Creation - Step5'
                }


                //                下拉数据
                ajax.post(api.INVWINEDROPDOWN, {
                    code: 'SO_ORDERTYPE'
                }).then(res => {
                    this.stepSelectData.orderType = res.data
                })
                ajax.post(api.INVWINEDROPDOWN, {
                    code: 'DELIVERY_MODE'
                }).then(res => {
                    this.stepSelectData.deliveeryMode = res.data
                })
                ajax.post(api.INVWINECOURRIER).then(res => {
                    this.stepSelectData.courrierData = res.data
                })
                ajax.post(api.INVWINEDROPDOWN, {
                    code: 'ITEM_REMARK'
                }).then(res => {
                    this.stepSelectData.itemRemarkData = res.data
                })
                ajax.post(api.INVWINEDROPDOWN, {
                    code: 'TMS_DISTRICT'
                }).then(res => {
                    this.stepSelectData.tmsDistrict = res.data
                })

            },




            findTempSoValAjax() {
                //   if(this.initCloseValue == undefined  && (this.isview != 'nonMerStep3' && this.isview != 'nonMerStep4' && this.isview != 'nonMerStep5')){
                ajax.post(api.INVWINEFINDTEMPSOORDERINFO).then(res => {
                    let arr = res.data.invTempDetailList
                    if (arr != null || (arr != undefined && arr.length > 0)) {
                        for (let i in arr) {
                            arr[i].receiveDate = moment(arr[i].receiveDate).format("YYYY-MM-DD");
                            if (arr[i].orderQty > 10) {
                                arr[i].orderQtyFlag = false
                            } else {
                                arr[i].orderQtyFlag = true
                            }
                        }
                    }
                    this.initCloseValue = res.data
                })
                // }
            },
            findTempSoValAjax2(val) {

                ajax.post(api.INVWINEFINDTEMPSOORDERINFO).then(res => {
                    let arr = res.data.invTempDetailList
                    if (arr != null || (arr != undefined && arr.length > 0)) {
                        for (let i in arr) {
                            arr[i].receiveDate = moment(arr[i].receiveDate).format("YYYY-MM-DD");
                            if (arr[i].orderQty > 10) {
                                arr[i].orderQtyFlag = false
                            } else {
                                arr[i].orderQtyFlag = true
                            }
                        }
                    }
                    this.initCloseValue = res.data

                    this.isview = val
                })


            },
            setInitCloseValue(val) {
                this.initCloseValue = val;
            },
            setIsview(val) {
                this.isview = val
            },
            getGoType(val) {
               
                if(val == 'Next'){
                    this.nextClick()
                }else if (val == 'Back') {
                    this.goBack()
                } else {
                    this.isview = val
                }

            },
            getValue(obj) {
                if (obj.type == 'nonMerStep1') {
                    this.sellLiquor.nonMerStep1 = obj.data
                } else if (obj.type == 'nonMerStep2') {
                    this.sellLiquor.nonMerStep2 = obj.data
                } else if (obj.type == 'nonMerStep3') {
                    this.sellLiquor.nonMerStep3 = obj.data
                } else if (obj.type == 'nonMerStep4') {
                    this.sellLiquor.nonMerStep4 = obj.data
                }
            },
            nextClick() {
                if (this.isview == "nonMerStep1") {
                    this.isview = "nonMerStep2"
                } else if (this.isview == "nonMerStep2") {
                    this.isview = "nonMerStep3"
                } else if (this.isview == "nonMerStep3") {
                    this.isview = "nonMerStep4"
                } else if (this.isview == "nonMerStep4") {
                    this.isview = "nonMerStep5"
                }
            },
            goBack() {
                if (this.isview == "nonMerStep2") {
                    this.isview = "nonMerStep1"
                } else if (this.isview == "nonMerStep3") {
                    this.isview = "nonMerStep2"
                } else if (this.isview == "nonMerStep4") {
                    this.isview = "nonMerStep3"
                } else if (this.isview == "nonMerStep5") {
                    this.isview = "nonMerStep4"
                }
            },
            menuGoType(type) {
                //  保存当前页面数据
                 if (this.isview == "nonMerStep2") {
                      this.$refs.refnonMerStep2.goTypeClick(type);
                 }else if (this.isview == "nonMerStep3") {
                    this.$refs.refnonMerStep3.goTypeClick(type); // 切换的时候调保存
                } else if (this.isview == "nonMerStep4") {
                    this.$refs.refnonMerStep4.goTypeClick(type); // 切换的时候调保存
                } else {
                    this.isview = type
                }
            },
            getGoClose() {
                this.visible = false
                 this.isview = 'nonMerStep1'
            },
            closeDrawer() {
                // let that = this
                // this.$confirm({
                //     title: 'Do you want to save before leave this step?',
                //     okText: 'Yes',
                //     okType: 'danger',
                //     cancelText: 'No',
                //     onOk() {
                //         if(that.$refs.refnonMerStep3 != undefined){
                //           that.$refs.refnonMerStep3.savenonMerStep3()
                //         }
                //         if(that.$refs.refnonMerStep4 != undefined){
                //             that.$refs.refnonMerStep4.savenonMerStep4()
                //         }
                //         that.visible = false
                //     },
                //     onCancel() {
                //         ajax.post(api.INVWINECLEARTEMP).then(res=>{})
                //         that.visible = false
                //     }
                // });
                let params = {
                    // title:'标题',
                    width: '500px',
                    content: 'Do you want to save before leave this step?',
                    leftBtnName: this.$t('publicLang.Cancel'),
                    centerBtnName: this.$t('publicLang.No'),
                    rightBtnName: this.$t('publicLang.Yes'),
                }
                this.$refs.confirm3Button.show(params)
            },
            closeWindowBack(val) {
                console.info(val)
                if (val == 2) {
                    ajax.post(api.INVWINECLEARTEMP).then(res => {})
                    this.visible = false
                    this.isview = 'nonMerStep1'
                   
                } else if (val == 3) {

                    console.info(this.isview)
                    if (this.isview == 'nonMerStep2') {
                        if (this.$refs.refnonMerStep2 != undefined) {
                            this.$refs.refnonMerStep2.savenonMerStep2()
                        }
                    } else if (this.isview == 'nonMerStep3') {
                        if (this.$refs.refnonMerStep3 != undefined) {
                            this.$refs.refnonMerStep3.savenonMerStep3()
                        }
                    } else if (this.isview == 'nonMerStep4') {
                        if (this.$refs.refnonMerStep4 != undefined) {
                            this.$refs.refnonMerStep4.savenonMerStep4()
                        }
                    } else if (this.isview == 'nonMerStep5') {
                        if (this.$refs.refnonMerStep5 != undefined) {
                            this.$refs.refnonMerStep5.savenonMerStep5()
                        }
                    }
                    this.visible = false
                }
            },
        }
    }
</script>
<style lang="less">
    //  .v-enter,
    //   .v-leave-to{

    //       opacity: 0;
    //       transform: translateX(10px);
    //   }

    //   .v-enter-active,
    //   .v-leave-active{
    //       transition: all 0.5s ease;
    //   }



    .liquorDrawerLeft>.ant-drawer-content-wrapper {
        left: 50%;
        margin-left: -590px;
    }

    .ant-drawer-header {
        padding: 16px;
    }

    .headerSteps {
        border-bottom: 1px solid #b7b7b7;
        color: #707070;
        padding-left: 16px;

        .stepsAvtiveBorder {
            padding: 0 4px;
            border-bottom: 2px solid #3b62c2;
            font-weight: 800;
            color: #3b62c2;
        }

        .headerStepsTitle {
            font-size: 12px;
            line-height: 17px;
        }
    }
</style>